import React, { useCallback } from 'react'
import { Box, Button, Typography } from '@mui/material'
import LockOutlined from '@mui/icons-material/LockOutlined'
import { useNavigate } from 'react-router-dom'

interface AccessDeniedProps {
  title?: string
  message?: string
}

const lockIconSx = { fontSize: 48, color: '#707070' } as const

const containerSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 400,
  gap: 1,
  padding: 4,
  textAlign: 'center',
} as const

const lockIcon = <LockOutlined sx={lockIconSx} />

const AccessDenied: React.FC<AccessDeniedProps> = ({
  title = 'Access Denied',
  message = 'You do not have permission to view this page.',
}) => {
  const navigate = useNavigate()
  const handleClick = useCallback(() => navigate('/'), [navigate])

  return (
    <Box sx={containerSx}>
      {lockIcon}
      <Typography variant="h6" sx={{ color: '#211F1F', mt: 1 }}>
        {title}
      </Typography>
      <Typography variant="body1" sx={{ color: '#707070' }}>
        {message}
      </Typography>
      <Button variant="outlined" onClick={handleClick} sx={{ mt: 2 }}>
        Go to Dashboard
      </Button>
    </Box>
  )
}

export default React.memo(AccessDenied)
